import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#69005b',
  width = '100%',
  className = '',
  viewBox = '0 0 146.316 101.208',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Grupo_6002" data-name="Grupo 6002" transform="translate(-500 -156)">
      <path
        id="male-solid"
        className="icon"
        d="M18.976,0A12.651,12.651,0,1,1,6.325,12.651,12.651,12.651,0,0,1,18.976,0m9.488,28.465H26.219a17.372,17.372,0,0,1-14.485,0H9.488A9.488,9.488,0,0,0,0,37.953V64.836A4.744,4.744,0,0,0,4.744,69.58H7.907V96.463a4.744,4.744,0,0,0,4.744,4.744H25.3a4.744,4.744,0,0,0,4.744-4.744V69.58h3.163a4.744,4.744,0,0,0,4.744-4.744V37.953A9.488,9.488,0,0,0,28.465,28.465Z"
        transform="translate(500 156)"
        fill={fill}
      />
      <path
        id="female-solid"
        className="icon"
        d="M31.712,0A12.651,12.651,0,1,1,19.061,12.651,12.651,12.651,0,0,1,31.712,0M55.291,70.011,45.8,32.058a4.744,4.744,0,0,0-4.6-3.593H38.955a17.372,17.372,0,0,1-14.485,0H22.224a4.744,4.744,0,0,0-4.6,3.593L8.134,70.011a4.746,4.746,0,0,0,4.6,5.895h11.07V96.463a4.744,4.744,0,0,0,4.744,4.744h6.325a4.744,4.744,0,0,0,4.744-4.744V75.906h11.07a4.746,4.746,0,0,0,4.6-5.895Z"
        transform="translate(536.881 156)"
        fill={fill}
        opacity="0.61"
      />
      <path
        id="female-solid-2"
        className="icon"
        data-name="female-solid"
        d="M31.712,0A12.651,12.651,0,1,1,19.061,12.651,12.651,12.651,0,0,1,31.712,0M55.291,70.011,45.8,32.058a4.744,4.744,0,0,0-4.6-3.593H38.955a17.372,17.372,0,0,1-14.485,0H22.224a4.744,4.744,0,0,0-4.6,3.593L8.134,70.011a4.746,4.746,0,0,0,4.6,5.895h11.07V96.463a4.744,4.744,0,0,0,4.744,4.744h6.325a4.744,4.744,0,0,0,4.744-4.744V75.906h11.07a4.746,4.746,0,0,0,4.6-5.895Z"
        transform="translate(590.881 156)"
        fill={fill}
      />
    </g>
  </svg>
);

export default SVG;
